import { isMobile } from "../common/helpers.js";

const redirectToDemoPaymentPage = async (e) => {
    e.preventDefault();

    const response = await fetch("/ajax/generate-demo-payment-page-link/", {
        headers: {
            "X-Requested-With": "XMLHttpRequest",
        },
    });

    const { linkToRedirect } = await response.json();
    if (isMobile()) {
        location.href = linkToRedirect;
        return;
    }
    const tabTarget = e.target.target || "_blank";
    window.open(linkToRedirect, tabTarget);
};

const init = () => {
    const linksToDemoPaymentPage = document.querySelectorAll(
        ".ns-link-to-demo-payment-page"
    );

    linksToDemoPaymentPage.forEach((linkElement) => {
        linkElement.addEventListener("click", redirectToDemoPaymentPage);
        linkElement.addEventListener("touchstart", redirectToDemoPaymentPage);
    });
};

window.addEventListener("DOMContentLoaded", init, false);
